import * as _hm from './_hf';
import * as _ht from './_ht';

import * as icv from 'src/icv';

import * as gs from './_csGbl'; // server 適用外

/*
export const c = (pCdn?: _ht.s, pbLtt?: _ht.b, pbDmn?: _ht.b) => { // 廃止予定
  const _gUserz = useGblz('user');
  const _bLtt = pbLtt ?? true;
  const _bDmn = pbDmn ?? true;
  let _cdn = '';
  if (_bLtt) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_vsn=_ltt`;
  if (_bDmn) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_dmn=${_gUserz.crt._dmn}`
  if (hf.f(pCdn)) _cdn += (_cdn == '' ? ' ' : ' AND ') + pCdn;
  return _cdn;
};
*/

export const vdd = (
  bVsn?: _ht.b, 
  bDmn?: _ht.b, 
  bDlt?: _ht.b
) => { // version, domain, delete : common condition
//  const _gUserz = useGblz('user');
  const _gUserz = gs.useUserz();
  //hf.l(`cmFTH 24: ${hf.s(_gUserz.crt)}`);
  let _cdn = '';
  if (bDlt ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `COALESCE(_dlt,-1) <> 1`
  if (bDmn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_dmn = ${_gUserz.crt._dmn}`
  if (bVsn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_vsn = _ltt`;
  //hf.l(`cmFTH 29: ${_cdn}`);
  return _cdn;
};

const ufmDatz = (pz: _ht.dz, dmn?: _ht.n) => { // server 適用外
  const _gUserz = gs.useUserz();
  return {
    ... pz,
    _dmn: dmn ?? _gUserz.crt?._dmn,
//    _who: _gUserz.crt._10rz._fst,
    _who: _gUserz.crt?._10rz?._key,
  }
};

export const ectAsync = async (pz: { // execute
  tgt: _ht.s,
  dz: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/ect';
  const _dz = pz;
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const getTknAsync = async (pz: {
  _dmn: _ht.n,
  _31r_fst: _ht.n,
  cgy: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/tkn';
  const _dz = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: pz,
  });
_hm.l(`_cmFTH 77: ${_hm.s(_dz)}`);
  if (!_dz.err) {
    return _dz.data;
  }
  else {
    return undefined;
  }
};

export const sendAsync = (pz: {
  url: _ht.s,
  mtd?: 'POST' | 'GET',
  dz?: _ht.dz,
}):Promise<{ err?: _ht.s|null, data?: _ht.a| null }> => new Promise( _exit1 => {
  const _dz = {
    mode: 'cors',
    method: pz.mtd ?? 'POST',
    body: pz.dz ? _hm.s(pz.dz) : null,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  };
  fetch(pz.url, _dz as _ht.a)
  .then( (_rst: _ht.a) => _rst.json())
  .then( (_rst: _ht.a) => {
    _exit1({ err: null, data: ((_rst) ? _rst : null) });
  })
  .catch( _err => {
    _exit1({ err: _err, data: null });
  });
});

export const loadAllAsync = async (pz: { // server 適用外
  frcUdt?: () => void,
  ldrz?: _ht.dz,
  phs?: _ht.s,
  bfrAsync?: () => _ht.ls,
  crtAsync?: () => _ht.ls,
  udtAsync?: () => _ht.ls,
  atrAsync?: () => _ht.ls,
}) => {
  if (pz.ldrz) pz.ldrz.show();
//  _hm.l(`cmFTH 73: here`);
  if (pz.bfrAsync) await Promise.all(pz.bfrAsync());
//  _hm.l(`cmFTH 75: here`);
  if ( pz.phs == 'crt' ) { // new
    if (pz.crtAsync) await Promise.all(pz.crtAsync());
  }
  else { // edit
    if (pz.udtAsync) await Promise.all(pz.udtAsync());
  }
  if (pz.atrAsync) await Promise.all(pz.atrAsync());
  if (pz.ldrz) pz.ldrz.hide();
//  _hm.l(`cmFTH 84: here`);
  if (pz.frcUdt) pz.frcUdt();
//  _hm.l(`cmFTH 86: here`);
};

export const loadAllAsync2 = async (pz: { // server 適用外
  frcUdt?: () => void,
  ldrz?: _ht.dz,
  phs?: _ht.s,
  bfrAsync?: () => _ht.ls,
  crtAsync?: () => _ht.ls,
  udtAsync?: () => _ht.ls,
  atrAsync?: () => _ht.ls,
}) => {
  if (pz.ldrz) pz.ldrz.show();
  //_hm.l(`cmFTH 73: here`);
  if (pz.bfrAsync) await _hm.ectSrlAsync(pz.bfrAsync());
  //_hm.l(`cmFTH 75: here`);
  if ( pz.phs == 'crt' ) { // new
    if (pz.crtAsync) await _hm.ectSrlAsync(pz.crtAsync());
  }
  else { // edit
    if (pz.udtAsync) await _hm.ectSrlAsync(pz.udtAsync());
  }
  if (pz.atrAsync) await _hm.ectSrlAsync(pz.atrAsync());
  if (pz.ldrz) pz.ldrz.hide();
  //_hm.l(`cmFTH 84: here`);
  if (pz.frcUdt) pz.frcUdt();
  //_hm.l(`cmFTH 86: here`);
};

export const loadLsAsync = async (pz: {
  tgt: _ht.s, 
  cdn?: _ht.s,
  fld?: _ht.s,
  tailz?: {
    odr?: _ht.s,
    ost?: _ht.n,
    lmt?: _ht.n,
  },
  lwrz?: _ht.dz,
  cvt?: (data: _ht.a) => _ht.a,
}) => {
  const _url = icv.appz?.urlb + '/findAll';
  const _dz = {
    ... pz,
    fld: pz.fld ?? '_fst as key, _pfx as pfx, *',
  };
  //_hm.l(`_cmFTH 179: ${_hm.s(_dz)}`)
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    //_dz2.data.map((dz2a: _ht.dz) => {
    //  _hm.l(`_cmFTH 186: ${dz2a._fst}, ${_hm.s(dz2a)}`)
    //})
    return pz.cvt ? pz.cvt(_dz2.data) : _dz2.data;
  }
  else {
    return null;
  }
};

export const loadDzAsync = async (pz: {
  tgt: _ht.s, 
  cdn: _ht.s,
  fld?: _ht.s,
  lwrz?: _ht.dz,
  cvt?: (data: _ht.a) => _ht.a,
}) => {
  const _url = icv.appz?.urlb + '/findOne';
  const _dz = {
    ... pz,
    fld: pz?.fld ?? '*',
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });

  if (!_dz2.err) {
    return pz.cvt ? pz.cvt(_dz2.data) : _dz2.data;
  }
  else {
    return null;
  }
};

export const ugdDzAsync = async (pz: { // upgrade
  tgt: _ht.s, 
  dmn?: _ht.n,
  dz: _ht.dz,
  lwrz?: _ht.dz,
  atrs?: _ht.ls, // 後処理
  dlys?: _ht.ls, // 遅延処理
}) => {
  const _url = icv.appz?.urlb + '/ugdOne';
  const _dz = {
    ... pz,
    dz: ufmDatz(pz.dz, pz.dmn), // server は ufmDatz 適用外
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const upsDzAsync = async (pz: { // upsert
  tgt: _ht.s, 
  dmn?: _ht.n,
  cdn?: _ht.s,
  dz: _ht.dz,
  atrs?: _ht.ls, // 後処理
  lwrz?: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/upsAll';
  const _dz = {
    ... pz,
    dz: ufmDatz(pz.dz, pz.dmn), // server は ufmDatz 適用外
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendCodeAsync = async (pz: {
  dmn: _ht.n,
  eml: _ht.s, 
  cdn?: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/sendCode';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const cfmCodeAsync = async (pz: { // confirm
  dmn: _ht.n,
  eml: _ht.s, 
  cdn?: _ht.s,
  code: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/cfmCode';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data as _ht.dz;
  }
  else {
    return null;
  }
};

export const cfmIdAsync = async (pz: { // confirm
  dmn: _ht.n,
  id: _ht.s, 
  cdn?: _ht.s,
  pwd: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/cfmId';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const cfmNbrAsync = async (pz: { // confirm
  id: _ht.s, 
  code: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/cfmNbr';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendDrtMailAsync = async (pz: { // sendmail
  fromName?: _ht.s,
  tos?: _ht.s[] | _ht.s,
  bccs?: _ht.s[] | _ht.s,
  sjt?: _ht.s,
  msg?: _ht.s,
  user?: _ht.s,
  pwd?: _ht.s,
}) => {
//  const _url = icv.appz?.urlb + '/mail';
//  const _url = icv.appz?.urlb + '/mailDrt';
  const _url = icv.appz?.urlb + '/mailPost';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  await _hm.waitAsync(1000); // 連続送信を抑制
  return _dz2;
};
export const sendMailAsync = sendDrtMailAsync;

export const sendPostMailAsync = async (pz: { // sendmail post
  fromName?: _ht.s,
  tos?: _ht.s[] | _ht.s,
  bccs?: _ht.s[] | _ht.s,
  sjt?: _ht.s,
  msg?: _ht.s,
  user?: _ht.s,
  pwd?: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/mailPost';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  return _dz2;
};

export const sendMailsAsync = async (mails: { // 廃止予定
  fromName?: _ht.s,
  tos?: _ht.s[] | _ht.s,
  bccs?: _ht.s[] | _ht.s,
  sjt?: _ht.s,
  msg?: _ht.s,
  user?: _ht.s,
  pwd?: _ht.s,
}[]) => {
  await _hm.ectSrlAsync(mails.map((_mailz: _ht.dz) => async () => {
    await sendMailAsync(_mailz);
    return true;
  }));
};

export const sendClwAsync = async (pz: { // send clockwork
  _a0rt1110i: _ht.n,
  _a0ra1110t: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/clw';
  const _dz = pz;
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};
